var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcIrrMicro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_1269)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9H45V15.5333H0V9Z",
    fill: "#4ABCCF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3887 14.8845H30.6136V21.4179H14.3887V14.8845ZM22.5012 36.5434C23.6532 36.5434 24.7581 36.0858 25.5727 35.2712C26.3873 34.4566 26.8449 33.3517 26.8449 32.1997C26.8449 30.6005 25.3965 27.0056 22.5012 21.4179C19.6058 27.0056 18.1574 30.6005 18.1574 32.1997C18.1574 33.3517 18.615 34.4566 19.4296 35.2712C20.2443 36.0858 21.3491 36.5434 22.5012 36.5434Z",
    fill: "#4ABCCF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_1269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIrrMicro);
export default __webpack_public_path__ + "static/media/ic-irr-micro.793cef71798ccd39f7d6daa374d07cc8.svg";
export { ForwardRef as ReactComponent };